import { defineStore } from 'pinia';
import { fetchApiCredits} from "@/services/ppApi";
import { useAccountStore } from '@/stores/account';

export const useApiCreditsStore = defineStore('apiCredits', {
    state: () => {
        return {
            apiCredits: [],
            loading: false,
            error: null,
            found: 0
        }
    },
    getters: {
        ppCredits: (state) => {
            return state.apiCredits?.filter(credit => credit.endpoint === 'new_prospects')[0] || false;
        },
    },
    actions: {
        resetApiCredits() {
            this.$reset();
        },
        async fetchApiCredits() {
            this.loading = true;
            this.error = null;

            try {
                const params = {
                    account_id: useAccountStore().account.account_id,
                    add_details: 1
                };

                const response = await fetchApiCredits(params);

                if(typeof response.data.credits === 'object' && Object.keys(response.data.credits).length > 0) {
                    this.apiCredits = Object.values(response.data.credits);
                } else {
                    this.apiCredits = response.data.credits;
                }
                this.found = response.data.found;
            } catch (error) {
                this.apiCredits = [];
                this.found = 0;
                this.error = error;
            } finally {
                this.loading = false;
            }
        },
        async getApiCredits() {
            if (!this.loading) {

                const needsFetch =
                    !this.apiCredits ||
                    this.apiCredits.length === 0 ||
                    !this.ppCredits ||
                    !Object.prototype.hasOwnProperty.call(this.ppCredits, 'credits_used_month');

                if (needsFetch) {
                    await this.fetchApiCredits();
                }
            }
            return this.apiCredits;
        },
        updatePpCredits(credits) {
            if(!credits) return;

            if (!this.apiCredits.some(credit => credit.endpoint === 'new_prospects')) {
                this.apiCredits = [{ ...credits, endpoint: 'new_prospects' }];
            } else {
                this.apiCredits = this.apiCredits.map(credit => {
                    if (credit.endpoint === 'new_prospects') {
                        return { ...credit, ...credits };
                    }
                    return credit;
                });
            }
        }
    }
});
